import { useState, useEffect } from "react";
import axios from "axios";
import { OptionType } from "../controls/ComboboxMI";

export interface IEmployeDetailsResult {
    login: string,
    id: number,
    name: string,
    surname: string,
    givenName: string,
    department: string,
    mail: string,
    telephoneNumber: string,
    cellphone: string,
    location: string,
    position: string,
    logManagerName: string,
    sapId: string,

    errorMessage?: string,
}

type GetEmployeDetailsApi = () => [
    IEmployeDetailsResult,
    (d: number | string) => void,
    boolean,
    boolean
];

export const useGetEmployeDetailsApi: GetEmployeDetailsApi = () => {
    const [data, setData] = useState<IEmployeDetailsResult>(null);
    const [logId, setLogId] = useState<string | number>();
    const [isLoading, setIsLoading] = useState(false);
    const [isError, setIsError] = useState(false);

    useEffect(() => {
        const fetchData = async () => {
            setIsError(false);
            setIsLoading(true);
            try {
                const result = await axios('/EmployeeDetails/GetEmployeeDetails/?logId=' + logId + '&_=' + new Date().getTime());
                setData(result.data);
            } catch (error) {
                console.error(error);
                setIsError(true);
            }
            setIsLoading(false);
        };

        if (logId == undefined)
            return;

        fetchData();

    }, [logId]);
    return [data, setLogId, isLoading, isError];
}

export interface IResponsibilityArea {
    MainTasks: string,
    Customers: string,
}

export interface IPositionGauge {
    Id: number,
    GaugeName: string,
    GaugeValue: string,
}

export interface IMainFinancialGauge {
    Id: number,
    Budget: string,
    YearlyPln: number,
    YearlyEur: number,
}

export interface IProfileData {
    relationId: number,
    id: number,
    name: string,
    company: string,
    departmentId: number | null,
    department: string,
    departmentCode: string,
    superiorDepartment: string,
    superiorDepartmentCode: string,
    positionPurpose: string,
    positionComplexity: string,
    requiredQualifications: string,
    description: string,
    isDataProcessed: boolean,
    directlyReportingPeopleNumber: number,
    indirectlyReportingPeopleNumber: number,
    influencedPeopleNumber: number,
    responsibilityAreas: IResponsibilityArea[],
    mainFinancialGauges: IMainFinancialGauge[],
    positionGauges: IPositionGauge[],
    inceptionDate: string,
    expirationDate: string,
    authorizationContent: string,
    employeeId: number,
    relationStatus: string,

    personProfilePdfUrl: string,
}


type IGetPersonProfilesApi = () => [
    IProfileData[],
    (d: number) => void,
    boolean,
    boolean
];

export const useGetPersonProfilesApi: IGetPersonProfilesApi = () => {
    const [data, setData] = useState<IProfileData[]>(null);
    const [logId, setLogId] = useState<number>();
    const [isLoading, setIsLoading] = useState(false);
    const [isError, setIsError] = useState(false);

    useEffect(() => {
        const fetchData = async () => {
            setIsError(false);
            setIsLoading(true);
            try {
                const result = await axios('/EmployeeDetails/PersonProfile/?logId=' + logId + '&_=' + new Date().getTime());
                setData(result.data);
            } catch (error) {
                console.error(error);
                setIsError(true);
            }
            setIsLoading(false);
        };

        if (logId == undefined)
            return;

        fetchData();
    }, [logId]);
    return [data, setLogId, isLoading, isError];
}

function dataMapper(item: any): OptionType {

    var lbl = item.Name;
    return {
        label: lbl,
        value: item.Id
    };
}

export const loadEmployess = (
    text: string,
    subordinates: boolean,
    subordinatesTree: boolean,
    maxRows: number,
    filterId: string,
    filters: string,
    callback: (data: OptionType[]) => void) =>
{
    (window as any).$.ajax({
        url: "/Resources/GetEmployeesAutocomplete/",
        dataType: "json",
        data: {
            maxRows: maxRows,
            startsWith: text,
            subordinates: subordinates ? "True": "False",
            subordinatesTree: subordinatesTree,
            filterId: filterId,
            filters: filters,
        },
        success: (data: any[]) => {
            var results: OptionType[] = data.map(dataMapper);
            callback(results);
        }
    });
}